import script from "./BdriveContent.vue?vue&type=script&setup=true&lang=js"
export * from "./BdriveContent.vue?vue&type=script&setup=true&lang=js"

import "./BdriveContent.vue?vue&type=style&index=0&id=50fbbfa8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50fbbfa8"]])

export default __exports__